"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactApi = exports.ContactSubject = void 0;
const base_1 = require("../base");
const globalImportUrl = require("url");
const axios_1 = require("axios");
var ContactSubject;
(function (ContactSubject) {
    ContactSubject["PasswordForgotten"] = "passwordForgotten";
    ContactSubject["PersonalInfosAccess"] = "personalInfosAccess";
    ContactSubject["PersonalInfosEdit"] = "personalInfosEdit";
    ContactSubject["EmailEdit"] = "emailEdit";
    ContactSubject["GuideReaction"] = "guideReaction";
    ContactSubject["ReportParticipatoryEntry"] = "reportParticipatoryEntry";
    ContactSubject["ChangeSubscription"] = "changeSubscription";
    ContactSubject["AdvertisementContactRequest"] = "advertisementContactRequest";
    ContactSubject["Other"] = "other";
})(ContactSubject = exports.ContactSubject || (exports.ContactSubject = {}));
function ContactApiAxiosParamCreator(configuration) {
    return {
        contact(contact, options = {}) {
            if (contact === null || contact === undefined) {
                throw new base_1.RequiredError("Contact", "Required parameter Contact was null or undefined when calling contact.");
            }
            const localVarPath = `/contact`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof contact !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(contact !== undefined ? contact : {})
                : contact || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function ContactApiFp(configuration) {
    return {
        contact(Contact, options) {
            const localVarAxiosArgs = ContactApiAxiosParamCreator(configuration).contact(Contact, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class ContactApi extends base_1.BaseAPI {
    contact(Contact, options) {
        return ContactApiFp(this.configuration).contact(Contact, options)(this.axios, this.basePath);
    }
}
exports.ContactApi = ContactApi;
